type Props = {
  value: number;
  onChange: (next: number) => void;
  label?: string;
  min?: number;
};

export function ServingsStepper({ value, onChange, label = "servings", min = 1 }: Props) {
  return (
    <div className="servings" role="group" aria-label="servings">
      <button onClick={() => onChange(Math.max(min, value - 1))} aria-label="decrease">−</button>
      <span className="v">{value}</span>
      <button onClick={() => onChange(value + 1)} aria-label="increase">+</button>
      <span className="label">{label}</span>
    </div>
  );
}
